import React, { useState, useEffect } from 'react';
import TagsInput from '@incoqnito.io/react-tagsinput';
import FormControl from "@material-ui/core/FormControl";
// @material-ui/core components
import { makeStyles } from '@material-ui/core'

import Send from "@material-ui/icons/Send";
import ViewList from "@material-ui/icons/ViewList";
import { Editor } from "@tinymce/tinymce-react";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import axios from 'axios';
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Check from "@material-ui/icons/Check";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import ISO6391 from "iso-639-1";
import moment from "moment";
import Datetime from "react-datetime";
import { connect } from 'react-redux';
import CustomSelect from "components/CustomSelect/CustomSelect"
import "react-table/react-table.css";
import { api_url } from 'redux/config.js';
import ReactTable from "react-table";

import Toast from 'views/Toast/Toast';
import Muted from "components/Typography/Muted"
import { useSelector } from 'react-redux';
import { Delete, Reply } from '@material-ui/icons';
import { CallApi } from 'utils/Request';
import LoadingModal from 'components/Loading/Loading';
import ReactTables from 'views/Other/Tables/ReactTables';
import CustomCheckbox from 'components/CustomSelect/CustomCheckbox';
import { TransReactTable } from 'components/CustomReactTable/TransReactTable';
import { useTranslation } from 'react-i18next';
import { verifyEmail } from 'utils/Validate';

const useStyles = makeStyles((theme) => {
    return {
        ...regularFormsStyle,
        descriptionTextArea: {
            width: "100%",
            height: 150
        },
        emailTags: {
            width: "100%",
            borderBottom: "1px solid #D2D2D2 !important"
        },
        descriptionTextArea: {
            width: "100%",
            height: 150
        }
    };
})


export default function SurveyRateMessages() {
    const classes = useStyles()
    const { t } = useTranslation()
    const [rateMessages, setRateMessages] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    // new plan
    const [message, setMessage] = useState('')
    const [minRate, setMinRate] = useState(0)
    const [maxRate, setMaxRate] = useState(1)
    const [email, setEmail] = useState('')

    useEffect(() => {
        loadData()
    }, [])
    const loadData = () => {
        setIsLoading(true)
        CallApi({
            url: 'rate_message/list',
            method: 'get',
        }).then((res) => {
            if (res.success) {
                setRateMessages(res.data)
            } else {
                Toast(400, res.error)
            }
        }).finally(() => {
            setIsLoading(false)
        })
    }

    const onAdd = () => {
        const newmessage = {
            email,
            minRate,
            maxRate,
            message
        }
        if (minRate >= maxRate) {
            Toast(400, t('Invalid form data'))
            return
        }
        if (message.trim().length == 0) {
            Toast(400, t('Please put message'))
            return
        }
        if (email.trim().length < 2) {
            Toast(400, t('Invalid email format'))
        }
        if (!verifyEmail(email)) {
            Toast(400, t('Invalid email format'))
            return
        }
        setIsLoading(true)
        CallApi({
            url: 'rate_message/add',
            method: 'post',
            data: newmessage
        }).then((res) => {
            if (res.success) {
                loadData()
            } else {
                Toast(400, res.error)
            }
        }).finally(() => {
            setIsLoading(false)
        })
    }
    const onDeletePlan = (id) => {
        if (!window.confirm(t('Are you sure?'))) {
            return
        }
        setIsLoading(true)
        CallApi({
            url: 'rate_message/delete/' + id,
            method: 'delete',
        }).then((res) => {
            if (res.success) {
                loadData()
            } else {
                Toast(400, res.error)
            }
        }).finally(() => {
            setIsLoading(false)
        })
    }
    const rows = rateMessages.map((rp, key) => {
        return {
            ...rp,
            actions: <div>
                <Button color='danger' size='sm' onClick={() => onDeletePlan(rp.id)}><Delete /></Button>
            </div>
        }
    })
    return (
        <div>
            <GridContainer>
                <GridItem xs={12} sm={12}>
                    <Card>
                        <CardHeader color="success" icon>
                            <CardIcon color="success">
                                <Reply />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>{t('Add new rate message')}</h4>
                        </CardHeader>
                        <CardBody>
                            <GridContainer>
                                <GridItem>
                                    <CustomInput
                                        id="min"
                                        labelText={t("Min")}
                                        formControlProps={{
                                            className: classes.noPadding,
                                            onChange: e =>
                                                setMinRate(e.target.value),
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            type: "number",
                                            value: minRate
                                        }}
                                    />
                                </GridItem>
                                <GridItem>
                                    <CustomInput
                                        id="max"
                                        labelText={t("Max")}
                                        formControlProps={{
                                            className: classes.noPadding,
                                            onChange: e =>
                                                setMaxRate(e.target.value),
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            type: "number",
                                            value: maxRate
                                        }}
                                    />
                                </GridItem>
                                <GridItem>
                                    <CustomInput
                                        id="email"
                                        labelText={t("Email")}
                                        formControlProps={{
                                            className: classes.noPadding,
                                            onChange: e =>
                                                setEmail(e.target.value),
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            value: email
                                        }}
                                    />
                                </GridItem>
                                <GridItem>
                                    <textarea
                                        className={classes.descriptionTextArea}
                                        placeholder={t('Message')}
                                        onChange={e => {
                                            setMessage(e.target.value)
                                        }}
                                    />
                                </GridItem>
                            </GridContainer>
                            <Button color='success' onClick={onAdd}>{t('Save')}</Button>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardHeader color="success" icon>
                            <CardIcon color="success">
                                <Reply />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>{t('Survey Rate Messages')}</h4>
                        </CardHeader>
                        <CardBody>
                            <TransReactTable
                                data={rows}
                                columns={[
                                    {
                                        Header: t("Min"),
                                        accessor: "min_rate"
                                    },
                                    {
                                        Header: t("Max"),
                                        accessor: "max_rate"
                                    },
                                    {
                                        Header: t('Email'),
                                        accessor: 'email'
                                    },
                                    {
                                        Header: t('Message'),
                                        accessor: "message"
                                    },
                                    {
                                        Header: "Actions",
                                        accessor: "actions",
                                        sortable: false,
                                        filterable: false
                                    }
                                ]}
                                defaultPageSize={20}
                                className="-striped -highlight"
                            />
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
            {isLoading && <LoadingModal />}
        </div>
    );
}